// valid image widths supported by go-image-v2
export const ALLOWED_SIZES = [
  50, 75, 100, 120, 150, 200, 240, 300, 360, 375, 400, 500, 600, 700, 750, 800, 850, 900, 950, 1000,
  1250, 1500, 1600, 1800, 2000, 2200, 2400, 2600, 3000, 3200, 3500, 3700, 4000,
];

export const DEFAULT_IMAGE_SIZE = 750;

export const ALLOWED_IMAGE_TYPE = ['jpeg', 'png', 'webp'];
